import { writable } from 'svelte/store';

// guarda as informações do formulário de cartão
const values = {
  cardForm: {
    name: '',
    number: '',
    expiry: '',
    cvc: '',
    save: true,
  },
}
export const cardForm = writable(values.cardForm)
cardForm.reset = () => cardForm.set(values.cardForm) // reset function

// indica se o checkout woocommerce está esperando
// por uma validação dos dados do cartão e também
// se o hash já foi criado (caso necessário)
export const waitingCardValidation = writable(false)

// guarda o hash do cartão quando gerado
export const cardHash = writable('')

// guarda os valores das parcelas disponíveis
export const installments = writable([]);

// indica se está cadastrando novo cartão ou usando um já cadastrado
// list = o usuário está escolhendo um cartão cadastrado
// form = o usuário está cadastrando novo cartão
export const checkoutMode = writable('list');

